export const emptyStringToNull = (value: string, originalValue: string) => {
  return originalValue === "" ? null : value;
};

export const NaNToNull = (_: any, originalValue: any) =>
  originalValue ? Number(originalValue) : null;

export const stringToNumber = (value: string) => {
  return value ? parseInt(value) : null;
};
